import React, { memo, useCallback } from 'react';
import {
  ArrowLeft, ArrowRight, ChevronLeft, ChevronRight,
} from 'react-feather';
import './scroll-button.scss';
import PropTypes from 'prop-types';
import { HorizontalTabScrollTypes } from '../../constants';
import Button, { ButtonSizes, ButtonTypes } from '../../../button';
import Icon from '../../../icon';

/* eslint-disable react/jsx-props-no-spreading */
const ScrollButton = ({
  type, side, onClick, disabled,
}) => {
  const handleButtonClick = useCallback(() => {
    onClick(side);
  }, [side, onClick]);

  const renderArrowLeftIcon = useCallback((props) => (
    <Icon {...props} icon={ArrowLeft} />
  ), []);

  const renderArrowRightIcon = useCallback((props) => (
    <Icon {...props} icon={ArrowRight} />
  ), []);

  const renderChevronLeftIcon = useCallback((props) => (
    <Icon {...props} icon={ChevronLeft} />
  ), []);

  const renderChevronRightIcon = useCallback((props) => (
    <Icon {...props} icon={ChevronRight} />
  ), []);

  switch (type) {
    case HorizontalTabScrollTypes.ARROW:
      return (
        <Button
          borderLess
          disabled={disabled}
          onClick={handleButtonClick}
          size={ButtonSizes.XXX_SMALL}
          className="htc-scroll-button"
          type={ButtonTypes.PRIMARY_OUTLINED}
          renderIcon={side === 'left' ? renderArrowLeftIcon : renderArrowRightIcon}
        />
      );

    case HorizontalTabScrollTypes.CHEVRON:
    case HorizontalTabScrollTypes.CHEVRON_OUTLINED:
      return (
        <Button
          disabled={disabled}
          onClick={handleButtonClick}
          size={ButtonSizes.XXX_SMALL}
          className="htc-scroll-button"
          borderLess={type === HorizontalTabScrollTypes.CHEVRON}
          renderIcon={side === 'left' ? renderChevronLeftIcon : renderChevronRightIcon}
          type={type === HorizontalTabScrollTypes.CHEVRON ? ButtonTypes.PRIMARY_OUTLINED
            : ButtonTypes.SECONDARY}
        />
      );

    default:
      return null;
  }
};

ScrollButton.propTypes = {
  side: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(Object.values(HorizontalTabScrollTypes)).isRequired,
};

export default memo(ScrollButton);
